import { createContext, useContext } from "react";

const PackContext = createContext({
  packId: ''
});

export const PackProvider = ({ value, children }) => (
  <PackContext.Provider value={value}>
    {children}
  </PackContext.Provider>
);

export const usePackContext = () => {
  const context = useContext(PackContext);

  if (context === undefined) {
    throw new Error('usePackContext must be used within a PackContext')
  }

  return context
}
